import { useState, type FormEvent, type ReactElement } from "react";
import { trpc } from "../../api";
import { useI18n } from "../../i18n";
import { ErrorNotice } from "../../ui";

export function ChangePasswordPage({ forced, onChanged }: { forced?: boolean; onChanged: () => void }): ReactElement {
  const { t } = useI18n();
  const [currentPassword, setCurrent] = useState("");
  const [newPassword, setNext] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [mismatch, setMismatch] = useState(false);

  const change = trpc.auth.changePassword.useMutation({ onSuccess: onChanged });

  function submit(event: FormEvent): void {
    event.preventDefault();
    if (newPassword !== confirmation) { setMismatch(true); return; }
    setMismatch(false);
    change.mutate({ currentPassword, newPassword });
  }

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={submit}>
        <h1 style={{ color: "var(--brand)" }}>{t("common.changePassword")}</h1>

        {forced === true && (
          <div className="alert alert-info">
            Your password was set by an administrator. Please choose your own before continuing.
          </div>
        )}

        <ErrorNotice error={change.error} />
        {mismatch && <div className="alert alert-error">The two passwords do not match.</div>}

        <div className="field">
          <label htmlFor="current">{t("common.currentPassword")}</label>
          <input id="current" type="password" autoComplete="current-password" required value={currentPassword} onChange={(e) => setCurrent(e.target.value)} />
        </div>

        <div className="field">
          <label htmlFor="next">{t("common.newPassword")}</label>
          <input id="next" type="password" autoComplete="new-password" required minLength={10} value={newPassword} onChange={(e) => setNext(e.target.value)} />
          <span className="muted" style={{ fontSize: "0.82rem" }}>At least 10 characters, and not only numbers.</span>
        </div>

        <div className="field">
          <label htmlFor="confirm">Confirm new password</label>
          <input id="confirm" type="password" autoComplete="new-password" required value={confirmation} onChange={(e) => setConfirmation(e.target.value)} />
        </div>

        <button type="submit" className="btn btn-primary" style={{ width: "100%" }} disabled={change.isPending}>
          {t("common.save")}
        </button>
      </form>
    </div>
  );
}
